import { generateTimeseriesMap } from './retirementSeriesGenerator'

const investmentOptions = {
	'Conservador': 2,
	'Moderado': 4,
	'Agressivo': 6
}
const getUV = (finalEquity, spending, INSSIncome, retiredSpending) => {
	if (finalEquity > 0) {
		if (finalEquity > retiredSpending) {
			return retiredSpending
		} else {
			return finalEquity
		}
	} else {
		return 0
	}
}

const getAMT = (finalEquity, spending, INSSIncome, retiredSpending) => {
	if (finalEquity <= 0) {
		return retiredSpending
	} else {
		if (finalEquity < retiredSpending) {
			return -(finalEquity - retiredSpending)
		} else {
			return 0
		}
	}
}
// finalEquity <=0 ? spending: 0
//

export const transform = (retirementData) => {
	const seriesData = {
		age: retirementData.age,
		retirementAge: retirementData.independenceAge,
		lifeExpectancy: 90,
		savingCapacity: retirementData.monthlySave,
		totalInvestments: retirementData.savedMoney,
		expectedInterest: investmentOptions[retirementData.investment],
		INSSIncome: retirementData.retirement !== "Não" ? retirementData.INSSmonthlyRetirement: 0,
		INSSage: retirementData.retirement !== "Não" ? retirementData.INSSage: 0,
		retirementPlannedIncome: retirementData.desiredRetirement,
	}
	const map = generateTimeseriesMap(seriesData)
	const arr = Array.from(map).reduce((p, c) => {
		const cAge = c[0].toString()
		const cData = c[1]

		const finalEquity = Number(cData.finalEquity)
		const spending = Number(cData.spending)
		const INSSIncome = Number(cData.INSSIncome)
		const retiredSpending = Number(cData.retiredSpending)

		// pv: Investimentos, uv, Retiradas, amt: Ausencia de renda
		const uv = getUV(finalEquity, spending, INSSIncome, retiredSpending)
		const amt = getAMT(finalEquity, spending, INSSIncome, retiredSpending)
		return [...p, {
			age: cAge,
			pv: finalEquity,
			uv,
			amt,
			inss: INSSIncome
		}]
	}, [])

	const lastYear = arr[arr.length - 1]
	return {
		positiveResult: lastYear.amt === 0,
		retirementArray: arr,
	}
}


